module.exports = {
  COMMAND: "COMMAND",
  HTTP: "HTTP",
  HTTPS: "HTTPS",
  TCP: "TCP",
  MESOS_HTTP: "MESOS_HTTP",
  MESOS_HTTPS: "MESOS_HTTPS",
  MESOS_TCP: "MESOS_TCP"
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/HealthCheckProtocols.js